import { Controller } from "stimulus"
import M from "../materialize"

export default class ModalController extends Controller {

  instance = null

  static get targets() {
    return ['modal']
  }
  initialize() {
    console.log("initializing modal")
    this.instance = M.Modal.init(this.modalTarget)
  }
  // data-modal-open-param="compare" opens the modal when the page's url has
  // ?compare=true
  connect() {
    const param = this.data.get("openParam")
    if (param && new URLSearchParams(window.location.search).get(param) === "true") {
      this.instance.open()
    }
  }
  // open(e) {
  //   e.preventDefault()
  //   this.instance.open()
  // }
  // close(e) {
  //   e.preventDefault()
  //   this.instance.close()
  // }
  disconnect() {
    console.log("instance:", this.instance)
    this.instance.destroy()
  }
}
